import { render, staticRenderFns } from "./formContainer.vue?vue&type=template&id=6c4d45f6&lang=pug&"
import script from "./formContainer.vue?vue&type=script&lang=js&"
export * from "./formContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports